import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Utility from '@/utils/Utility'

export default {
  name: 'TypeText',
  data () {
    return {
      inited: false,
      noticeType: null
    }
  },
  mounted () {
    this.noticeType = this.noticeTypeMstModel.filter(item => item.noticeTypeMstUuid === this.values.inpNoticeType)[0].noticeType
    console.log(this.noticeType)
    console.log(this.values.inpDeliveryContents)
    this.inited = true
  },
  computed: {
    ...mapState({
      noticeTypeMstModel: state => state.noticeForm.noticeTypeMstModel,
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      deliveryType:'noticeForm/deliveryType'
    }),

    // show
    showModule () {
      return key => {
        if (!this.inited) return false

        const list = {
          // text : ['title', 'body', 'soundFile', 'linkUrl'],
          // text_image : ['title', 'body', 'attachments', 'soundFile', 'linkUrl'],
          // text_movie : ['title', 'body', 'attachments', 'linkUrl'],
          text : ['title', 'body', 'soundFile', 'webSites'],
          text_image : ['title', 'body', 'attachments', 'webSites'],
          text_movie : ['title', 'body', 'attachments', 'webSites'],
          pdf : ['title', 'attachments'],
          sound : ['soundFile'],
          opinionaire : ['opinionaire', 'soundFile'],
          sound_broadcast : ['soundFile'],
          keikai: ['keikaiLevel', 'soundFile'],
          images: ['attachments'],
          movies: ['attachments'],
          emergency_notice:['title', 'body', 'soundFile', 'webSites'],
          important_notice:['title', 'body', 'soundFile', 'webSites', 'category'],
          rapid_info: ['title', 'body', 'soundFile', "category"]
        }

        return list[this.noticeType].indexOf(key) !== -1
      }
    },

    showAnswer () {
      return key => this.values.inpDeliveryContents[key] !== null
    },

    fileLabel() {
      return this.noticeType === 'text_image' ||
        this.noticeType === 'images'
        ? '画像ファイル'
        : this.noticeType === 'text_movie' ||
          this.noticeType === 'movies'
          ? '動画ファイル'
          : this.noticeType === 'pdf'
            ? 'PDF'
            : '音声ファイル'
    },

    // result
    result () {
      console.log(this.values.inpDeliveryContents)
      return key => {
        const value = this.values.inpDeliveryContents[key]
        switch (key) {
          case 'body':
            return value
          case 'attachments':
            return value && value.length
              ? value.map(item => item.name).join('、')
              : ''
          case 'soundFile':
            return value ? value.name : ''
          case 'keikaiLevel':
            return Utility.getConstantsLabel(['Notice', 'KeikaiLevel'], value)
          case 'webSites':
            return value && value.length
              ? value.map(item => {
                return '<a href="' + Utility.sanitizeUrl(item.url) + '" target="_blank">' + item.name + '</a>'
              }).join('<br />')
              : ''
          default:
            return value
        }
      }
    },

    classFirst () {
      return key => {
        switch (key) {
          case 'attachments':
            return this.noticeType === 'images' ||
              this.noticeType === 'movies'
          case 'soundFile':
            return this.noticeType !== 'text' &&
              this.noticeType !== 'text_image' &&
              this.noticeType !== 'text_movie'
          default:
            return false
        }
      }
    },

    classMt3 () {
      return key => {
        switch (key) {
          case 'soundFile':
            return this.noticeType === 'opinionaire'
          default:
            return false
        }
      }
    }
  },
}
